import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  loopMode: 'forEach',
  inputData: 'data',
  count: 10,
  maxIterations: 100,
};

export default defaults;
